<template>
    <ValidationObserver ref="observer" tag="div">
        <div v-if="localApp" class="edit-modal-wrapper p-2">
            <b-row>
                <b-col md="4">
                    <b-card no-body class="mb-3">
                        <b-card-header class="bg-light font-weight-bold">
                            {{ $t('details') }}
                        </b-card-header>
                        <b-list-group flush>
                            <b-list-group-item><strong>{{ $t('name_surname') }}:</strong> {{ localApp.name }} {{ localApp.surname }}</b-list-group-item>
                            <b-list-group-item><strong>{{ $t('national_id') }}:</strong> {{ localApp.national_id }}</b-list-group-item>
                            <b-list-group-item><strong>{{ $t('email') }}:</strong> {{ localApp.email }}</b-list-group-item>
                            <b-list-group-item><strong>{{ $t('phone') }}:</strong> {{ localApp.phone }}</b-list-group-item>
                            <b-list-group-item><strong>{{ $t('university') }}:</strong> {{ localApp.home_university_name }}</b-list-group-item>
                            <b-list-group-item><strong>{{ $t('program') }}:</strong> {{ getLocaleText(localApp, 'bau_program_name') }}</b-list-group-item>
                            <b-list-group-item ><strong>{{ $t('application_status') }}:</strong> {{ getLocaleText(localApp, 'application_status_name') }}</b-list-group-item>
                            <b-list-group-item ><strong>{{ $t('accepttance_status') }}:</strong> {{ getLocaleText(localApp, 'acceptance_status_name') }}</b-list-group-item>
                            <b-list-group-item ><strong>{{ $t('document_status') }}:</strong> {{$t(localApp.document_status) }}</b-list-group-item>
                            <b-list-group-item ><strong>{{ $t('pin_code') }}:</strong> {{$t(localApp.pin) }}</b-list-group-item>
<!--                            <b-list-group-item ><strong>{{ $t('application_completion_status') }}:</strong> {{ getLocaleText(localApp, 'completion_status_name')}}</b-list-group-item>-->
                        </b-list-group>
                    </b-card>

                </b-col>
                <b-col md="8" v-if="showDocumentTab || showCourseTab">
                    <b-tabs content-class="mt-3" card>
                        <b-tab v-if="showDocumentTab" :title="$t('document_approval')" active :disabled="!isRoleStudentAffairs && !isActiveRole">
                            <DocumentApprovalTab
                                :local-app="localApp"
                                :is-active-role="isActiveRole"
                                @update-application="setLocalApp"
                            />
                        </b-tab>
                        <b-tab v-if="showCourseTab" :title="isGraduate ? $t('institute_review') : $t('academic_unit_review')" active :disabled="isRoleStudentAffairs && !isActiveRole">
                            <CourseReviewTab
                                :local-app="localApp"
                                :is-graduate="isGraduate"
                                :check-approver="checkApprover"
                                @update-application="setLocalApp"
                            />
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </div>
    </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import DocumentApprovalTab from "./tabs/DocumentApprovalTab.vue";
import CourseReviewTab from "./tabs/CourseReviewTab.vue";

export default {
    name: "EditModal",
    components: {
        ValidationObserver,
        DocumentApprovalTab,
        CourseReviewTab
    },
    props: {
        application: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            localApp: null,
        }
    },
    computed: {
        isGraduate() {
            if (!this.localApp) return false;
            return ['YL', 'D'].includes(this.localApp.target_program_level);
        },
        getActiveRol() {
            return this.$store.getters['auth/getActiveRole']
        },
        isRoleStudentAffairs() {
            return ['OI'].includes(this.getActiveRol)
        },
        showDocumentTab() {
            return ['OI'].includes(this.getActiveRol)
        },
        showCourseTab() {
            return ['FS', 'FSY', 'ES', 'ESY'].includes(this.getActiveRol)
        },
        activeStep() {
            if (!this.localApp) return [];
            const status = this.localApp.application_status ?? null
            let rol = [];
            if (['waiting_approval', 'document_waiting', 'rejected'].includes(status)) {
                rol = ['OI'];
            } else if (['waiting_secretary_approval', 'course_rejected'].includes(status)) {
                rol = ['FS', 'FSY', 'ES', 'ESY'];
            }
            return rol
        },
        isActiveRole() {
            const activeRol = this.getActiveRol;
            return this.activeStep && this.activeStep.includes(activeRol);
        },
        isRequiredDocument() {
            return this.localApp?.documents?.every((item) => ['approved', 'rejected'].includes(item.status)) ?? false;
        },
        checkApprover() {
            if (['FS', 'FSY'].includes(this.getActiveRol) && this.isGraduate) {
                return true
            }
            if (['ES', 'ESY'].includes(this.getActiveRol) && !this.isGraduate) return true
            return false
        }
    },
    watch: {
        application: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.setLocalApp(val)
                }
            }
        }
    },
    methods: {
        setLocalApp(value) {
            this.localApp = JSON.parse(JSON.stringify(value))

            if (this.localApp?.courses) {
                this.localApp.courses.sort(((a, b) => a.course_code.localeCompare(b.course_code)))
            }
        }
    }
}
</script>

<style scoped>
.gap-2 {
    gap: 0.5rem;
}
</style>
